import { TableBody, TableItem, Text } from '@genial/components';
import { Typography } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import React from 'react';
import { useRecoilValue } from 'recoil';

import { homeGlobalState } from '../../../../../../store/home/capture/atom';
import { columnWidthsFutureMaturities } from '../../constants';

import { FutureMaturitiesItemTypes } from '.';

export const FutureMaturitiesItemDesktop: React.FC<FutureMaturitiesItemTypes.Props> = ({
  item,
  onSelectAccount,
}) => {
  const { valueVisibility } = useRecoilValue(homeGlobalState);

  const truncateText = (text, maxLength) => {
    if (text.length > maxLength) {
      return text.substring(0, maxLength) + '...';
    }
    return text;
  };

  return (
    <TableBody testId="table-body">
      <TableItem
        align="center"
        width={columnWidthsFutureMaturities.date}
        testId="header-settlement-date">
        <Text color={'neutral.darkest'} variant="semibold">
          {item.relatedDateNormalized}
        </Text>
      </TableItem>
      <TableItem
        width={columnWidthsFutureMaturities.client}
        testId="header-settlement-client"
        onPress={() => onSelectAccount(item.customerAccountNumber)}>
        <Text color={'neutral.darkest'} variant="regular">
          {item.customerNameNormalized}
        </Text>
      </TableItem>
      <TableItem width={columnWidthsFutureMaturities.product} testId="header-settlement-client">
        <Text variant="regular">{truncateText(item.productNameNormalized, 30)}</Text>
        <Text color={'neutral.medium'} fontSize={Typography['fontsize.xs']} variant="regular">
          {item.productDescriptionNormalized}
        </Text>
      </TableItem>
      <TableItem align="center" width={columnWidthsFutureMaturities.value} testId="header-value">
        <Text
          color={valueVisibility ? 'neutral.black' : 'neutral.darkest'}
          fontWeight={Typography['fontweight.semibold']}
          fontSize={valueVisibility ? Typography['fontsize.md'] : Typography['fontsize.xxs']}
          letterSpacing={valueVisibility ? undefined : Typography['bullet.spacing']}>
          {valueVisibility
            ? Utils.Mask.Money(item.operationValueNormalized)
            : Typography['bullet.sequence']}
        </Text>
      </TableItem>
    </TableBody>
  );
};
